import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';

import { useForm } from "react-hook-form";
import Loading from '../../../Component/Loading/Loading';
import API from "../../../Services/BaseService";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import StateAndCity from '../../../Component/StateAndCity/StateAndCity'
import ManageAccountLinks from "../../../Component/ManageAccountLinks/ManageAccountLinks";
import appstore from '../../../assets/img/appstore.png';
import googleplay from '../../../assets/img/googleplay.png';
import StateAndCitySearch from '../../../Component/StateAndCity/StateAndCitySearch';
import PageNotFound from '../../FallBackUI/PageNotFound';
import { Button } from 'antd';
import { Modal } from 'react-bootstrap';

const EditLegalAccount = (props) => {
    const history = useHistory();
    const { id } = props.location.state;
    console.log("id", id)
    let { register, updateLegalAccount, formState: { errors }, reset } = useForm();
    // const { id } = useParams();
    const [accountObjc, setAccountObj] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [legalBusinessname, setLegalBusinessname] = useState("");
    const [EINnumber, setEINnumber] = useState("");
    const [dealershiplicense, setDealershiplicense] = useState("");
    const [taxid, setTaxid] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [cityId, setCityId] = useState("");
    const [state, setState] = useState("");
    const [stateId, setStateId] = useState("");

    const [zipcode, setZipcode] = useState("");
    const [zipcodeId, setZipcodeId] = useState("");

    const [loading, setLoading] = useState(true);

    const [dealershipLicenseexp, setDealershipLicenseexp] = useState("");
    const [dealershipLicenseexp1, setDealershipLicenseexp1] = useState("");

    const [taxidexp, setTaxidexp] = useState("");
    const [taxidexp1, setTaxidexp1] = useState("");


    const [firstnameError, setFirstnameError] = useState("");
    const [lastnameError, setLastnameError] = useState("");
    const [legalBusinessnameError, setLegalBusinessnameError] = useState("");
    const [EINnumberError, setEINnumberError] = useState("");
    const [dealershiplicenseError, setDealershiplicenseError] = useState("");
    const [taxidError, setTaxidError] = useState("");
    const [addressError, setAddressError] = useState("");
    const [dealershipLicenseexpError, setDealershipLicenseexpError] = useState("");
    const [taxidexpError, setTaxidexpError] = useState("");
    const [stateAndCityError, setStateAndCityError] = useState("")
    const [stateCityFlag, setStateCityFlag] = useState("");

    const [isOpen, setIsOpen] = useState(false);
    const successData = useSelector(state => state.LoginReducer.payload);

    const [editErrors, setEditErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const [confirmationFlag, setConfirmationFlag] = useState(false);

      //histroy 
      const [changesFlag, setChangesFlag] = useState("no");
      const [changesArray, setChangesArray] = useState([]);
      const [sateCityFlag, setSateCityFlag] = useState("");
      console.log(changesArray,"changesArray");

    const confirmationPopup = () => {

        setConfirmationFlag(!confirmationFlag)

    }

    const customButtonStyle = {
        backgroundColor: "RGB(189,6,44)",
        color: "white",
        height: '40px'
    };

    console.log("==successData==", successData)

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    const yesterday = moment().subtract(1, 'day');
    const disablePastDt = current => {
        return current.isAfter(yesterday);
    };

    const inputProps1 = {

        placeholder: dealershipLicenseexp,
        value: dealershipLicenseexp1
    };

    const Date1 = (event) => {
        if (event._isAMomentObject == true) {
            setDealershipLicenseexp1(event.format("YYYY/MM/DD"))
        }
    }
    const inputProps2 = {
        placeholder: taxidexp,
        value: taxidexp1
    };

    const Date2 = (event) => {
        if (event._isAMomentObject == true) {
            setTaxidexp1(event.format("YYYY/MM/DD"))
        }
    };
    const handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("")

   /*  const getStateName = (stateData, flag) => {
        setState(stateData)
        setStateCityFlag(flag)
    }

    const getCityName = (cityData) => {
        setCity(cityData)
    }

    const getZipCodeId = (zipData) => {
        setZipcode(zipData)
    } */

    const getError = (data, flag) => {
        console.log("reg flag", data, flag);
        setEditErrors(data)
        setErrorFlag(flag)
    }

    const updateAccount = (event) => {
        // setOpenLoader(true);
        event.preventDefault();

        setFirstnameError("")
        setLastnameError("")
        setLegalBusinessnameError("")
        setEINnumberError("")
        setDealershiplicenseError("")
        setTaxidError("")
        setAddressError("")
        setDealershipLicenseexpError("")
        setTaxidexpError("")
        setStateAndCityError("")



        if (!firstname) {
            setFirstnameError("First Name is required")
            return;
        }
        else if (firstname.length > 50) {
            setFirstnameError("First Name must not exceed 50 characters")
            return;
        }
        if (!lastname) {
            setLastnameError("Last Name is required")
            return;
        }
        else if (lastname.length > 50) {
            setLastnameError("Last Name must not exceed 50 characters")
            return;
        }
        if (!legalBusinessname) {
            setLegalBusinessnameError("Legal Businessname is required")
            return;
        }
        else if (legalBusinessname.length > 50) {
            setLegalBusinessnameError("Legal Businessname must not exceed 50 characters")
            return;
        }
        if (!EINnumber) {
            setEINnumberError("EIN Number is required")
            return;
        }
        else if (EINnumber.length < 10) {
            setEINnumberError("EIN # Must Have Nine Digits")
            return;
        }
        if (!dealershiplicense) {
            setDealershiplicenseError("Seller License is required")
            return;
        }
        else if (dealershiplicense.length > 50) {
            setDealershiplicenseError("Seller License must not exceed 50 characters")
            return;
        }
        if (!taxid) {
            setTaxidError("Tax Id is required")
            return;
        }
        else if (taxid.length > 50) {
            setTaxidError("Tax Id must not exceed 50 characters")
            return;
        }
        if (!address) {
            setAddressError("Address is required")
            return;
        }
        else if (address.length > 150) {
            setAddressError("Address must not exceed 150 characters")
            return;
        }
        if (!dealershipLicenseexp1 && !dealershipLicenseexp) {

            setDealershipLicenseexpError("Seller License exp is required")
            return;
        }
        if (!taxidexp1 && !taxidexp) {
            setTaxidexpError("Tax Id exp is required")
            return;
        }
        // if(!(typeof city==='string'?accountObjc.city_id:city) || !(typeof state==='string'?accountObjc.state_id:state) || !(zipcode===accountObjc.zipcode?accountObjc.zipcode_id:zipcode)){
        //     setStateAndCityError("State, City and Zipcode is required")
        //     return
        // }
        if (!(typeof state === 'string' ? accountObjc.state_id : state)) {
            setStateAndCityError("1")
            return
        }
        if (!(typeof city === 'string' ? accountObjc.city_id : city)) {
            setStateAndCityError("2")
            return
        }
        if (!(zipcode === accountObjc.zipcode ? accountObjc.zipcode_id : zipcode)) {
            setStateAndCityError("3")
            return
        }
        confirmationPopup()

    }
    const updateAccount1 = () => {

        const filteredChangesArray = changesArray.filter(change => !(change.oldvalue === '' && change.newvalue === ''));
        const filteredChangesflag = filteredChangesArray.length > 0 ? "yes" : "no"


        let request = {
            first_name: firstname,
            last_name: lastname,
            seller_legal_manage_id: id,
            ein_no: EINnumber,
            seller_license: dealershiplicense,
            tax_id: taxid,
            address: address,
            // city_id: city,
            // state_id: state,
            // zipcode_id: zipcode,
            /* city_id: stateCityFlag == "" ? typeof city === 'string' ? accountObjc.city_id : city : "",
            state_id: stateCityFlag == "" ? typeof state === 'string' ? accountObjc.state_id : state : "",
            zipcode_id: stateCityFlag == "" ? zipcode === accountObjc.zipcode ? accountObjc.zipcode_id : zipcode : "",
            city_name: stateCityFlag !== "" ? city : "",
            state_name: stateCityFlag !== "" ? state : "",
            zipcode: stateCityFlag !== "" ? zipcode : "", */
            state_id: sateCityFlag === "" ? typeof state === 'string' ? accountObjc.state_id : state : "",
            city_id: sateCityFlag === "" ? typeof city === 'string' ? accountObjc.city_id : city : "",
            zipcode_id: sateCityFlag === "" ? zipcode === accountObjc.zipcode ? accountObjc.zipcode_id : zipcode : "",
            state_name: sateCityFlag !== "" ? state : "",
            city_name: sateCityFlag !== "" ? city : "",
            zipcode: sateCityFlag !== "" ? zipcode : "",
            seller_license_exp: dealershipLicenseexp1 == "" || dealershipLicenseexp1 == null ? "" : dealershipLicenseexp1,
            tax_id_exp: taxidexp1 == "" || taxidexp1 == null ? "" : taxidexp1,
            bussiness_name: legalBusinessname,
            active: 1,
            updatedBy: successData.seller_id,
            seller_id: successData.seller_id,
            seller_dealer_id: successData.seller_dealer_id,
            seller_token: successData.seller_token,
            /* historylist: changesArray,
            valuechanges: changesFlag, */
            historylist: filteredChangesArray,
            valuechanges: filteredChangesflag,

        };
        console.log("check the legal request", request)
        // return
        API
            .post('seller_legal_manage/update', request)
            .then((response) => {
                if (response.data.success) {
                    const { data } = response;
                    togglePopup()
                    setPopupTitle("Edit Legal ManageAccount");
                    setPopupMsg(" Edit Legal ManageAccount is successfully Updated");
                    setPopupType("success");
                    setPopupActionType("redirect");
                    setPopupActionValue("ok");
                    setPopupActionPath("/manageaccount")

                } else {
                    togglePopup()
                    setPopupTitle("Edit Legal ManageAccount");
                    // setPopupMsg("Edit Legal ManageAccount is not update, Please try Again");
                    setPopupMsg(response.data.error.err);
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                }
            }, (error) => {
                // setOpenLoader(false);
                // console.log(error);
                togglePopup()
                setPopupTitle("Error");
                setPopupMsg("Something went wrong, Please try Again");
                setPopupType("error");
                setPopupActionType("close");
                setPopupActionValue("close");
            })
            .catch(function (error) {
                if (error.response) {
                    setEditErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    useEffect(() => {
        //   fetchAccountDetails();
        let request = {
            seller_legal_manage_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        };


        const state = API.post('seller_legal_manage/condition', request);
        state.then(res => {
            console.log("res", res.data.data)
            if (res.data.success === true) {
                setFirstname(res.data.data[0].first_name);
                setLastname(res.data.data[0].last_name);
                setLegalBusinessname(res.data.data[0].bussiness_name);
                setEINnumber(res.data.data[0].ein_no);
                setDealershiplicense(res.data.data[0].seller_license);
                setTaxid(res.data.data[0].tax_id);
                setAddress(res.data.data[0].address);
                setCity(res.data.data[0].city_name);
                setCityId(res.data.data[0].city_id);
                setStateId(res.data.data[0].state_id);
                setState(res.data.data[0].state_name);
                setZipcode(res.data.data[0].zipcode);
                setZipcodeId(res.data.data[0].zipcode_id)
                setDealershipLicenseexp(res.data.data[0].seller_license_exp);
                setTaxidexp(res.data.data[0].tax_id_exp);
                setAccountObj(res.data.data[0]);
                reset(res.data.data[0]);
                setLoading(false)

            }
            else {
                setEditErrors(res.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setEditErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }, [reset]);

   /*  const handleEINChange = (e) => {
        const inputSSN = e.target.value.replace(/\D/g, "");
        const inputLength = inputSSN.length;

        let formattedSSN = "";

        if (inputLength > 0) {
            formattedSSN = inputSSN.slice(0, 2);
            console.log("first 2 numbers", formattedSSN)
        }
        if (inputLength > 2) {
            formattedSSN += "-" + inputSSN.slice(2, 9);
            console.log("next 2 numbers", formattedSSN)

        }

        setEINnumber(formattedSSN);
    }; */

     //histroy 
    const handleFirstNameChange = (e) => {
        setChangesFlag("yes")
        const newValue = e.target.value;
        const oldvalue = accountObjc.first_name;
        setFirstname(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'First Name');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'First Name' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'First Name' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleLastNameChange = (e) => {
        setChangesFlag("yes")
        const newValue = e.target.value;
        const oldvalue = accountObjc.last_name;
        setLastname(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Last Name');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Last Name' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Last Name' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleLegalBusinessNameNameChange = (e) => {
        setChangesFlag("yes")
        const newValue = e.target.value;
        const oldvalue = accountObjc.bussiness_name;
        setLegalBusinessname(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Legal Business Name');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Legal Business Name' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Legal Business Name' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleEINChange = (e) => {
        setChangesFlag("yes")
        const inputSSN = e.target.value.replace(/\D/g, "");
        const inputLength = inputSSN.length;

        let formattedSSN = "";

        if (inputLength > 0) {
            formattedSSN = inputSSN.slice(0, 2);
        }
        if (inputLength > 2) {
            formattedSSN += "-" + inputSSN.slice(2, 9);
        }


        const newValue = e.target.value;
        const oldvalue = accountObjc.ein_no;
        setEINnumber(formattedSSN);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'EIN #');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'EIN #' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'EIN #' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleDealershipLicenseChange = (e) => {
        setChangesFlag("yes")
        const newValue = e.target.value;
        const oldvalue = accountObjc.seller_license;
        setDealershiplicense(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Seller License');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Seller License' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Seller License' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleTaxIdChange = (e) => {
        setChangesFlag("yes")
        const newValue = e.target.value;
        const oldvalue = accountObjc.tax_id;
        setTaxid(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Tax Id');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Tax Id' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Tax Id' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleAddressChange = (e) => {
        setChangesFlag("yes")
        const newValue = e.target.value;
        const oldvalue = accountObjc.address;
        setAddress(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Address');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Address' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Address' };
            setChangesArray([...changesArray, change]);
        }
    }

    const getStateName = (stateData, flag, type) => {
        setChangesFlag("yes")
        console.log(stateData, flag, type, "checking");
        setState(stateData)
        const oldvalue = accountObjc.state_name == null ? "" : accountObjc.state_name;
        setSateCityFlag(flag)
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue: oldvalue, newvalue: stateData, name: type };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: stateData, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getCityName = (cityData, flag, type) => {
        setChangesFlag("yes")
        setCity(cityData)
        const oldvalue = accountObjc.city_name == null ? "" : accountObjc.city_name;
         setSateCityFlag(flag)
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = {
                    ...updatedChangesArray[existingChangeIndex],
                    newvalue: cityData,
                };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: cityData, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getZipCodeId = (zipData, flag, type) => {
        setChangesFlag("yes")
        console.log(zipData, flag, type, "changing flag");
        setZipcode(zipData)
        const oldvalue = accountObjc.zipcode == null ? "" : accountObjc.zipcode;
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);
            /* const updatedFlag = flag || 'dropdown'; */
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { ...updatedChangesArray[existingChangeIndex], newvalue: zipData,/*  flag: updatedFlag */ };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: zipData, name: type,/*  flag: updatedFlag */ };
                return [...prevChangesArray, change];
            }
        });
    }

    
    const Dealershiplicenseexp = (event) => {
        if (event._isAMomentObject == true) {
            const newValue = event.format("YYYY/MM/DD");
            const oldvalue = accountObjc.seller_license_exp === null || accountObjc.seller_license_exp === "null" || accountObjc.seller_license_exp === undefined || accountObjc.seller_license_exp === "undefined" ? "" : accountObjc.seller_license_exp ;
            setDealershipLicenseexp1(newValue);
            const existingChangeIndex = changesArray.findIndex(change => change.name === 'Seller License Exp');
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Seller License Exp' };
                setChangesArray(updatedChangesArray);
                setChangesFlag("yes")
      
            } else {
                const change = { oldvalue, newvalue: newValue, name: 'Seller License Exp' };
                setChangesArray([...changesArray, change]);
                setChangesFlag("yes")
      
            }
        }
    }
    const Taxidexp = (event) => {
        if (event._isAMomentObject == true) {
            const newValue = event.format("YYYY/MM/DD");
            const oldvalue = accountObjc.tax_id_exp === null || accountObjc.tax_id_exp === "null" || accountObjc.tax_id_exp === undefined || accountObjc.tax_id_exp === "undefined" ? "" : accountObjc.tax_id_exp ;
            setTaxidexp1(newValue);
            const existingChangeIndex = changesArray.findIndex(change => change.name === 'Tax Id Exp Date');
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Tax Id Exp Date' };
                setChangesArray(updatedChangesArray);
                setChangesFlag("yes")   
      
            } else {
                const change = { oldvalue, newvalue: newValue, name: 'Tax Id Exp Date' };
                setChangesArray([...changesArray, change]);
                setChangesFlag("yes")
      
            }
        }
    }

    return (
        <div>


            <main id="main" className="inner-page">
                {errorFlag === true ? <PageNotFound error={editErrors} /> :
                    <>
                        {loading ? <Loading /> :
                            <div id="addaddress" className="addaddress_block">
                                <div className="container-fluid inner-page-space">
                                    <div class="common-heading">
                                        <div className="row">
                                            <div className="col-lg-4">
                                            </div>
                                            <div className="col-lg-4">
                                                <div class="title">
                                                    <p class="inner-title">Edit Legal Manage Account</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="addaddressblock col-lg-12">
                                        <div className="row content">
                                            <div className="col-lg-4 col-md-12 col-sm-12 mgaccountleftblock">
                                                <ManageAccountLinks />
                                            </div>
                                            <div className="col-lg-8 col-md-12 col-sm-12 flooraddform">
                                                <div className="adduserpage-inner">
                                                    <div className="col-lg-12">
                                                        <form className="registrationform"  >
                                                            <div className="row">
                                                                <div class="common-heading">
                                                                    <div className="row">
                                                                        <div className="col-lg-2">
                                                                            <div class="back-btn">
                                                                                <button className="back-btn-paymentform backBtn" onClick={() => history.push("/manageaccount")}><i className="icofont-arrow-left"></i> Back</button>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-8">
                                                                            <div class="title">
                                                                                <p class="inner-title">Edit Legal Manage Account</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.first_name} id="first_name" className="form-control textbox" placeholder="" onChange={handleFirstNameChange} />
                                                                        <label htmlFor="first_name" className={firstname != "" ? "input-has-value required" : ""}>First Name</label>
                                                                        <p className="form-input-error" >{firstnameError}</p>
                                                                    </div>

                                                                </div>
                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.last_name} id="last_name" className="form-control textbox" placeholder="" onChange={handleLastNameChange} />
                                                                        <label htmlFor="last_name" className={lastname != "" ? "input-has-value required" : ""}>Last Name</label>
                                                                        <p className="form-input-error" >{lastnameError}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.bussiness_name} id="legal_name" className="form-control textbox" placeholder="" onChange={handleLegalBusinessNameNameChange} />
                                                                        <label htmlFor="legal_name" className={legalBusinessname != "" ? "input-has-value required" : ""}>Legal Business Name</label>
                                                                        <p className="form-input-error" >{legalBusinessnameError}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" id="Ein_no" className="form-control textbox" placeholder="" value={EINnumber} onChange={handleEINChange} />
                                                                        <label htmlFor="Ein_no" className={EINnumber != "" ? "input-has-value required" : ""}>EIN Number</label>
                                                                        <p className="form-input-error" >{EINnumberError}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.seller_license} id="seller_license" className="form-control textbox" placeholder=""  onChange={handleDealershipLicenseChange} />
                                                                        <label htmlFor="seller_license" className={dealershiplicense != "" ? "input-has-value required" : ""}>Seller License</label>
                                                                        <p className="form-input-error" >{dealershiplicenseError}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.tax_id} id="tax_id" className="form-control textbox" placeholder="" onChange={handleTaxIdChange} />
                                                                        <label htmlFor="tax_id" className={taxid != "" ? "input-has-value required" : ""}>Tax Id</label>
                                                                        <p className="form-input-error" >{taxidError}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.address} id="address" className="form-control textbox" placeholder="" onChange={handleAddressChange} />
                                                                        <label htmlFor="address" className={address != "" ? "input-has-value required" : ""}>Address</label>
                                                                        <p className="form-input-error" >{addressError}</p>
                                                                    </div>
                                                                </div>
                                                                <StateAndCitySearch
                                                                    setStateValue={(stateData, flag) => getStateName(stateData, flag, 'state')}
                                                                    setCityValue={(cityData, flag) => getCityName(cityData, flag, 'city')}
                                                                    setZipcodeValue={(zipData, flag) => getZipCodeId(zipData, flag, 'zipcode')}
                                                                    setNewError={getError}
                                                                    isEdit={true}
                                                                    defaultStateValue={state}
                                                                    defaultCityValue={city}
                                                                    defaultZipcodeValue={zipcode}
                                                                    stateCityValidation={stateAndCityError}
                                                                    setRequired={"true"}

                                                                />
                                                                {/* <div className="col-sm-12 form-group state-error">
                            <p className="form-input-error1"> {stateAndCityError} </p>
                            </div> */}
                                                                <div className="col-sm-12 form-group datePickerBlock">
                                                                    <div className="tbox">
                                                                        <Datetime inputProps={inputProps1} timeFormat={false} dateFormat="YYYY/MM/DD"
                                                                            name="Date" id="ldate" isValidDate={disablePastDt}  onChange={Dealershiplicenseexp}
                                                                            class="form-control textbox" closeOnSelect={true} />
                                                                        <label htmlFor="ldate" className={dealershipLicenseexp != "" ? "input-has-value required" : ""}>Seller License Exp</label>
                                                                        <p className="form-input-error" >{dealershipLicenseexpError}</p>
                                                                    </div>
                                                                    {/* <label htmlFor="first_name" className={dealershipLicenseexp !="" ? "input-has-value" : ""}>Seller license exp</label> */}


                                                                </div>
                                                                <div className="col-sm-12 form-group datePickerBlock">
                                                                    <div className="tbox">
                                                                        <Datetime inputProps={inputProps2} timeFormat={false} dateFormat="YYYY/MM/DD"
                                                                            class="form-control textbox" id="edate" name="Date" closeOnSelect={true} isValidDate={disablePastDt} onChange={Taxidexp}
                                                                        />
                                                                        <label htmlFor="edate" title="Tax id exp Date" className={taxidexp != "" ? "input-has-value required" : ""}>Tax Id Exp Date</label>
                                                                        <p className="form-input-error" >{taxidexpError}</p>
                                                                    </div>
                                                                    {/* <label htmlFor="first_name" className={taxidexp!="" ? "input-has-value" : ""}>Tax id exp</label> */}



                                                                </div>
                                                                <div className="col-lg-12 loginBtn">
                                                                    <Button className="cta-btn" style={customButtonStyle}  onClick={updateAccount} >Update</Button>
                                                                </div>
                                                            </div>
                                                        </form>

                                                    </div>  </div></div></div></div></div></div>}</>}


                {confirmationFlag &&
                    <>
                        <Modal show={true} onHide={confirmationPopup} centered>
                            <Modal.Header className="Terms-login">
                                <h2>Edit confirmation</h2>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="CommonModalbody">
                                    <p>Are you sure,If you want to Edit Legal Account Information please confirm</p>
                                </div>

                                <div className="col-md-12 btns confirmation ">
                                    <button className="cta-btns" onClick={confirmationPopup} >CANCEL</button>
                                    <button className="cta-btns" onClick={updateAccount1} >OK</button>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </>}
                <section id="playstoreBlock" className="playstoreBlock">
                    <div className="container">
                        <div className="row content">
                            <div className="col-lg-12">
                                <img src={appstore} />
                                <img src={googleplay} />
                            </div>
                        </div>
                    </div>
                </section>
                {
                    isOpen &&
                    <CommonPopup
                        handleClose={togglePopup}
                        popupTitle={popupTitle}
                        popupMsg={popupMsg}
                        popupType={popupType}
                        popupActionType={popupActionType}
                        popupActionValue={popupActionValue}
                        popupActionPath={popupActionPath}
                    />
                }
            </main >

        </div >


    );
};

export default EditLegalAccount;